import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Form, Input, Select, Button, Divider, Upload } from "antd";
import backArrow from "../../../../Assets/Images/back-arrow.svg";
import { Option } from "antd/es/mentions";
import { TeamService } from "../../../../Services/API/TeamsService";
import { validatePhoneNumber } from "../../../../Utils/phoneNumberValidation";
import { participantServices } from "../../../../Services/API/participantsServices";
import Loader from "../../../../Components/Loader/Loader";
import { toast } from "react-toastify";

export default function ParticipantsCreate() {
  const navigate = useNavigate();
  const location = useLocation();
  const action = location?.state?.action;
  const state = location?.state?.data;
  const [form] = Form.useForm();
  const [Bulkform] = Form.useForm();
  const [teams, setTeams] = useState([]);
  const [loading, setLoading] = useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [bulkSubmitLoading, setBulkSubmitLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchTeams = () => {
    setLoading(true);
    TeamService.getAllTeams()
      .then((response) => {
        setTeams(response?.data);
        setLoading(false);
      })
      .catch((error) => {
        toast.error(error?.response?.data || "Something went wrong");
        setLoading(false);
        console.log(error);
      });
  };

  useEffect(() => {
    fetchTeams();
    if (state) {
      form.setFieldsValue({
        firstName: state?.participant_first_name,
        lastName: state?.participant_last_name,
        phone: state?.participant_phone_number,
        email: state?.participant_email,
        teams: state?.participant_team_id,
      });
    }
  }, [state]);

  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList;
  };

  const handleCreateParticipant = (values) => {
    setSubmitLoading(true);

    const participantServicePromise =
      action === "add"
        ? participantServices.addSingleParticipant(
            values?.firstName,
            values?.lastName,
            values?.phone,
            values?.email,
            values?.teams
          )
        : participantServices.updateParticipant(
            state?.id?.replace(/"/g, ""),
            values?.firstName,
            values?.lastName,
            values?.phone,
            values?.email,
            values?.teams,
            state?.created_by
          );

    participantServicePromise
      .then((response) => {
        toast.success(
          action === "add"
            ? "Participant added successfully"
            : "Participant updated successfully"
        );

        navigate("/");
      })
      .catch((error) => {
        const errorMessage =
          error?.response?.data ||
          (action === "add"
            ? "Error adding Participant"
            : "Error updating Participant");
        toast.error(errorMessage);
        console.log(error);
      })
      .finally(() => {
        setSubmitLoading(false);
      });
  };

  const handleSampleDownload = () => {
    participantServices
      .getSampleFile()
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response?.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "sample-file.xlsx");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((error) => {
        toast.error(
          error?.response?.data || "Error downloading the sample file"
        );
        console.log(error);
      });
  };

  const handleBulkUpload = (values) => {
    if (values.BulkFileExcel && values.BulkFileExcel.length > 0) {
      const file = values?.BulkFileExcel[0]?.originFileObj;
      const teamId = values?.bulkTeams;

      setBulkSubmitLoading(true);

      participantServices
        .addParticipant(file, teamId)
        .then((response) => {
          toast.success("Participants added successfully");
          navigate("/");
        })
        .catch((error) => {
          toast.error(error?.response?.data || "Error adding participants");
          console.log(error);
        })
        .finally(() => {
          setBulkSubmitLoading(false);
        });
    } else {
      toast.error("Please upload a file");
    }
  };

  return loading ? (
    <Loader />
  ) : (
    <div className="form-page">
      <div className="forms-header-component">
        <div className="back-btn-container">
          <img
            src={backArrow}
            className="back-arrow"
            onClick={() => navigate("/")}
            alt="Back to Fundraisers"
          />
        </div>
        <div className="heading-container">
          {action === "add"
            ? "Add New Participant"
            : `Edit - Participant - ${state?.participant_first_name}`}
        </div>
      </div>
      <div className="fundraiser-form-component">
        <div className="form-container">
          <Form
            className="form-component"
            form={form}
            labelCol={{
              span: 8,
            }}
            colon={false}
            onFinish={handleCreateParticipant}
          >
            <Form.Item
              className="form-item"
              label={<div className="form-label">First Name:</div>}
              name="firstName"
              rules={[
                {
                  required: true,
                  message: "Please Enter First Name",
                },
              ]}
            >
              <Input placeholder="First Name" />
            </Form.Item>
            <Form.Item
              className="form-item"
              label={<div className="form-label">Last Name:</div>}
              name="lastName"
              rules={[
                {
                  required: true,
                  message: "Please Enter Last Name",
                },
              ]}
            >
              <Input placeholder="Last Name" />
            </Form.Item>
            <Form.Item
              className="form-item"
              label={<div className="form-label">Phone Number:</div>}
              name="phone"
              rules={[
                {
                  validator: validatePhoneNumber,
                },
                {
                  required: true,
                  message: "please Enter Phone Number",
                },
              ]}
            >
              <Input placeholder="Phone Number" />
            </Form.Item>
            <Form.Item
              className="form-item"
              label={<div className="form-label">Email Id:</div>}
              name="email"
              rules={[
                { type: "email", message: "Please Enter a valid email!" },
                {
                  required: true,
                  message: "Please Enter Email Id",
                },
              ]}
            >
              <Input placeholder="Email Id" />
            </Form.Item>
            <Form.Item
              className="form-item"
              label={<div className="form-label">Team:</div>}
              name="teams"
              rules={[
                {
                  required: true,
                  message: "Please Select a Team",
                },
              ]}
            >
              <Select placeholder="Select team" allowClear className="select">
                {teams?.map((member) => (
                  <Option key={member?.id} value={member?.id}>
                    {member?.team_title}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Form>
        </div>
      </div>
      <div className="forms-btns-container">
        <Button
          className="save-btn"
          onClick={() => form.submit()}
          loading={submitLoading}
        >
          Save
        </Button>
        <Button className="cancel-btn" onClick={() => navigate("/")}>
          Cancel
        </Button>
      </div>
      {action === "add" && (
        <>
          <Divider style={{ borderWidth: 3 }} />
          <div className="forms-header-component bulk-upload-heading">
            <div className="heading-container">Bulk upload</div>
            <div>
              <Button className="bulk-btn" onClick={handleSampleDownload}>
                Download Sample File
              </Button>
            </div>
          </div>
          <div className="fundraiser-form-component">
            <div className="form-container">
              <Form
                className="form-component"
                form={Bulkform}
                labelCol={{
                  span: 8,
                }}
                colon={false}
                onFinish={handleBulkUpload}
              >
                <Form.Item
                  className="form-item"
                  label={<div className="form-label">Team:</div>}
                  name="bulkTeams"
                  rules={[
                    {
                      required: true,
                      message: "Please Select a Team",
                    },
                  ]}
                >
                  <Select
                    placeholder="Select team"
                    allowClear
                    className="select"
                  >
                    {teams?.map((member) => (
                      <Option key={member?.id} value={member?.id}>
                        {member?.team_title}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item
                  className="form-item"
                  label={<div className="form-label">Upload File:</div>}
                  name="BulkFileExcel"
                  valuePropName="fileList"
                  getValueFromEvent={normFile}
                  rules={[
                    {
                      required: true,
                      message: "Please Upload a file less than 10MB",
                    },
                  ]}
                >
                  <Upload
                    name="file"
                    beforeUpload={(file) => {
                      const isLt10M = file.size / 1024 / 1024 < 10;
                      if (!isLt10M) {
                        toast.error("File must be smaller than 10MB!");
                      }
                      return isLt10M ? true : Upload.LIST_IGNORE;
                    }}
                    accept=".xls,.xlsx"
                    listType="text"
                  >
                    <Button className="bulk-btn">Browse</Button>
                  </Upload>
                </Form.Item>
              </Form>
            </div>
          </div>
          <div className="forms-btns-container">
            <Button
              className="save-btn"
              onClick={() => Bulkform.submit()}
              loading={bulkSubmitLoading}
            >
              Save
            </Button>
            <Button className="cancel-btn" onClick={() => navigate("/")}>
              Cancel
            </Button>
          </div>
          <Divider style={{ borderWidth: 3 }} />
        </>
      )}
    </div>
  );
}
